import get from 'lodash.get';
import { graphql, readInlineData } from 'react-relay';

const REST_OF_WORLD_REGION = 'Rest of the World';
const FREE_SHIPPING_PRICE = 0;
const JEWELRY_VERTICAL = 'jewelry';

function getItemData(itemReference) {
    return readInlineData(
        graphql`
            fragment freeShippingHelpers_item on Item @inline {
                vertical
                shipmentQuotes {
                    isComplimentary
                    totalAmount {
                        amount
                    }
                    serviceMethod {
                        region {
                            regionName
                        }
                    }
                }
            }
        `,
        itemReference
    );
}

// FINDING-14549: Rest of world (ROW) shipping quotes are not considered in S/B free shipping, since items may
// have free shiping to ROW but not to user specifict region. However, few items in jewelry fall in to that
// situation and due to big marketing pushes around jewelry free shipping, we are temporarilyconsidering ROW quotes
// for jewelry vertical only on the FE until we revisit how free shipping is determined.
function isEligibleRestOfWorldFreeShipping({ vertical, regionName, hasFreeShipping }) {
    return hasFreeShipping && vertical === JEWELRY_VERTICAL && regionName === REST_OF_WORLD_REGION;
}

function isEligibleUserRegionFreeShipping({ userRegions, regionName, hasFreeShipping }) {
    const userRegionNames = (userRegions || []).map(region => region.displayName).filter(Boolean);
    return hasFreeShipping && userRegionNames.includes(regionName);
}

// userRegions will only populate for non-private IPs. If you are in office or vpn, manually set zipCode in localStorage userGeoInfo
export const getIsFreeShipping = ({ item, userRegions }) => {
    const itemData = getItemData(item);
    const shipmentQuotes = get(itemData, 'shipmentQuotes') || [];
    return !!shipmentQuotes.find(shipmentQuote => {
        const hasFreeShipping =
            get(shipmentQuote, 'isComplimentary') ||
            get(shipmentQuote, 'totalAmount.amount') === FREE_SHIPPING_PRICE;
        const regionName = get(shipmentQuote, 'serviceMethod.region.regionName');
        return (
            isEligibleUserRegionFreeShipping({
                userRegions,
                regionName,
                hasFreeShipping,
            }) ||
            isEligibleRestOfWorldFreeShipping({
                vertical: get(itemData, 'vertical'),
                regionName,
                hasFreeShipping,
            })
        );
    });
};
